exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs-trigger[data-v-721d0016]{position:relative;padding:.5rem 1.25rem;text-decoration:none;font-size:1rem;font-weight:700;text-transform:uppercase;color:#2460b8;border:1px solid #2460b8}@media screen and (max-width:650px){.tabs-trigger[data-v-721d0016]{display:block;margin-bottom:10px;border-radius:5px}.tabs-trigger[data-v-721d0016]:last-child{margin-bottom:0}}.tabs-trigger i[data-v-721d0016]{margin-right:5px}.tabs-trigger i[data-v-721d0016],.tabs-trigger span[data-v-721d0016]{display:inline-block;vertical-align:middle}@media screen and (min-width:650px){.tabs-trigger.active[data-v-721d0016]{background:#2460b8;color:#fff}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-721d0016","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Tabs/Trigger.vue
// module id = WTCO
// module chunks = 115 116